(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('app-attest-log', {
            parent: 'entity',
            url: '/app-attest-log?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.appAttestLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/app-attest-log/app-attest-logs.html',
                    controller: 'AppAttestLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                phone: null,
                status: null,
                endpoint: null,
                errorCode: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null,
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        phone: $stateParams.phone,
                        status: $stateParams.status,
                        endpoint: $stateParams.endpoint,
                        errorCode: $stateParams.errorCode,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        from: $stateParams.from,
                        to: $stateParams.to,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAttestLog');
                    $translatePartialLoader.addPart('appAttestStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('app-attest-log-detail', {
            parent: 'app-attest-log',
            url: '/app-attest-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.appAttestLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-detail.html',
                    controller: 'AppAttestLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appAttestLog');
                    $translatePartialLoader.addPart('appAttestStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppAttestLog', function($stateParams, AppAttestLog) {
                    return AppAttestLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'app-attest-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('app-attest-log-detail.edit', {
            parent: 'app-attest-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-dialog.html',
                    controller: 'AppAttestLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppAttestLog', function(AppAttestLog) {
                            return AppAttestLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('app-attest-log.new', {
            parent: 'app-attest-log',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-dialog.html',
                    controller: 'AppAttestLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                keyId: null,
                                challenge: null,
                                phone: null,
                                endpoint: null,
                                requestBodyJson: null,
                                appVersionCode: null,
                                signCount: null,
                                responseJson: null,
                                publicKeyData: null,
                                publicKeyDataContentType: null,
                                status: null,
                                errorCode: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('app-attest-log', null, { reload: 'app-attest-log' });
                }, function() {
                    $state.go('app-attest-log');
                });
            }]
        })
        .state('app-attest-log.edit', {
            parent: 'app-attest-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-dialog.html',
                    controller: 'AppAttestLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppAttestLog', function(AppAttestLog) {
                            return AppAttestLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('app-attest-log', null, { reload: 'app-attest-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('app-attest-log.delete', {
            parent: 'app-attest-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/app-attest-log/app-attest-log-delete-dialog.html',
                    controller: 'AppAttestLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppAttestLog', function(AppAttestLog) {
                            return AppAttestLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('app-attest-log', null, { reload: 'app-attest-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
